import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarViewComponent } from './components/calendar-view/calendar-view.component';
import { ErrorComponent } from './components/error/error.component';
import { LinkValidationGuard } from './guards/link-validation.guard';

const routes: Routes = [
  {
    path: 'calendar',
    component: CalendarViewComponent,
    canActivate: [LinkValidationGuard]
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: '',
    redirectTo: '/calendar',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
